import type { ReactNode } from 'react';

type DialogRole = 'STUDENT' | 'TEACHER' | 'ADMIN';

/** Presentation only: never use the theme class to decide access or actions. */
export function roleDialogClassName(role: DialogRole): string {
  return role === 'ADMIN' ? '' : ` role-dialog role-dialog--${role.toLowerCase()}`;
}

export function RoleDialogHeading({
  role,
  eyebrow,
  title,
  detail,
  busy,
  onClose,
}: {
  readonly role: DialogRole;
  readonly eyebrow?: string | undefined;
  readonly title: string;
  readonly detail?: ReactNode;
  readonly busy: boolean;
  readonly onClose: () => void;
}) {
  return (
    <header className="lobby-dialog-heading">
      <div>
        {role === 'ADMIN' && eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <h2>
          {title}
          {detail}
        </h2>
      </div>
      <button
        className="dialog-close"
        type="button"
        aria-label="关闭弹窗"
        disabled={busy}
        onClick={onClose}
      >
        ×
      </button>
    </header>
  );
}
